var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webPage"},[_c('header',{staticClass:"webPage-menu"},[_c('HeadTabbar',{attrs:{"rollColor":_vm.rollColor}})],1),_c('body',{staticClass:"webPage-content",class:[_vm.showRoll === true ? '' : 'hidden'],attrs:{"id":"content"}},[_c('router-view',{staticClass:"router-name"})],1),_c('FixTools')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }